<mat-card class="main-card" style="display: flex; flex-direction: column; height: 100%">
  <mat-table #table [dataSource]="commentService.datasource" style="max-height: 100%; flex:1 1; overflow:auto;">
    <ng-container matColumnDef="Comments">
      <mat-header-cell *matHeaderCellDef>Comments</mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.attributes.Comments}} </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
    <mat-row style="cursor: pointer;" *matRowDef="let element; columns: displayColumns" (click)="openDialog(element)" ></mat-row>
  </mat-table>
  <button mat-mini-fab [routerLink]="['new']" (click)="openDialog({attributes: {'GlobalID': 'new', 'ProjectFK': project_id }})" ><mat-icon>add</mat-icon></button>
</mat-card>
